import { CustomPalette, StatusTagType } from '../config/types';
import { STYLE_PARAMS_BY_STATUS } from '../constants/styleParamsByStatus';

export const getColorPaletteByStatus = (palette: CustomPalette, status: string) => {
  const colorPalette = STYLE_PARAMS_BY_STATUS[status];
  return {
    color: palette[colorPalette.colorPaletteName][colorPalette.colorType],
    contrastText: palette[colorPalette.colorPaletteName].contrastText,
  };
};

// FIXME: This are just fixes, but the whole status-color logic in the WHOLE application needs to be reworked from scratch
export const adjustColorToPalette = (colorPaletteName: string, colorType: string, palette: CustomPalette) => {
  return colorPaletteName === StatusTagType.DEFAULT
    ? palette.grey[600]
    : colorPaletteName === StatusTagType.MINOR
    ? palette.grey[300]
    : palette[colorPaletteName][colorType];
};
